import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { useEffect, useState } from 'react';
import FaqJsonSchema from 'components/Shared/FaqJsonSchema';
import Accordion from 'components/ui/ContentBlocks/Accordion';
import { useTranslation } from 'hooks/useTranslation';
import type { Faq } from 'types/Utilities';
import type { IFaqFields } from 'types/contentful/generated';

type Props = {
  items: IFaqFields[];
};

const FAQ = ({ items }: Props): JSX.Element | null => {
  const [faqItems, setFaqItems] = useState<Faq[]>([]);
  const { t } = useTranslation();

  const prepareFaqSchema = (): void => {
    const faqItems: Faq[] = [];

    for (const item of items) {
      faqItems.push({
        question: item.title,
        // eslint-disable-next-line
        // @ts-ignore
        answer: documentToHtmlString(item.answer.json),
      });
    }

    setFaqItems(faqItems);
  };

  useEffect(() => {
    if (items?.length) {
      prepareFaqSchema();
    }
  }, []);

  if (!items?.length) {
    return null;
  }

  return (
    <>
      <FaqJsonSchema items={faqItems} />
      <div className="max-w-screen-xl mx-auto px-5 lg:px-4 lg:grid md:grid-cols-3 mb-16 md:mt-16 lg:mt-24">
        <div>
          <h2 className="adelle-bold-section-headline">
            {t('doctorProfile.faq.title')}
          </h2>
        </div>
        <div className="col-span-2 lg:pl-12">
          <p className="mb-6">{t('doctorProfile.faq.intro')}</p>
          <Accordion>
            {items.map((item, i) => (
              <Accordion.Item key={i} title={item.title} text={item.answer} />
            ))}
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default FAQ;
